var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banner[data-v-3a898d6e]{width:657px;height:376px;background:url(" + escape(require("@/common/image/activtion.png")) + ") no-repeat;margin:0 auto 30px auto\n}\n.main[data-v-3a898d6e]{display:block;padding:80px 0\n}\n.refresh-tips[data-v-3a898d6e],.wait[data-v-3a898d6e]{text-align:center\n}\n.refresh-tips span[data-v-3a898d6e]{color:#00c4aa;cursor:pointer\n}", ""]);

// exports
